import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonWriters.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSourceJsonReader.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WsProtocolClass;
function WsProtocol() {
  if (WsProtocolClass === VOID) {
    class $ {
      constructor(webSocketConnection, listener) {
        this.webSocketConnection_1 = webSocketConnection;
        this.listener_1 = listener;
      }
      toByteString_l7d8zw_k$(_this__u8e3s4) {
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        writeAny($this$buildJsonByteString, _this__u8e3s4);
        return buffer.readByteString_nzt46n_k$();
      }
      toUtf8_g8folw_k$(_this__u8e3s4) {
        // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
        var buffer = new (Buffer())();
        var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
        writeAny($this$buildJsonString, _this__u8e3s4);
        return buffer.readUtf8_echivt_k$();
      }
      toMessageMap_saw0hw_k$(_this__u8e3s4) {
        var tmp;
        try {
          var tmp_0 = get_AnyAdapter().fromJson_po5g3w_k$(new (BufferedSourceJsonReader())((new (Buffer())()).writeUtf8_9rv3au_k$(_this__u8e3s4)), Key_getInstance().Empty_1);
          tmp = isInterface(tmp_0, KtMap()) ? tmp_0 : null;
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Exception()) {
            var e = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      sendMessageMapBinary_rwv9hc_k$(messageMap) {
        this.webSocketConnection_1.send_ut25s3_k$(this.toByteString_l7d8zw_k$(messageMap));
      }
      sendMessageMapText_ruv2y4_k$(messageMap) {
        this.webSocketConnection_1.send_oy6aea_k$(this.toUtf8_g8folw_k$(messageMap));
      }
      sendMessageMap_r8a026_k$(messageMap, frameType) {
        switch (frameType.ordinal_1) {
          case 0:
            this.sendMessageMapText_ruv2y4_k$(messageMap);
            break;
          case 1:
            this.sendMessageMapBinary_rwv9hc_k$(messageMap);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      *receiveMessageMap_t50udd_k$($completion) {
        while (true) {
          var map = this.toMessageMap_saw0hw_k$(yield* this.webSocketConnection_1.receive_qir1pc_k$($completion));
          if (!(map == null)) {
            return map;
          }
        }
      }
      *run_b0z2ng_k$($completion) {
        try {
          while (true) {
            this.handleServerMessage_s28ise_k$(yield* this.receiveMessageMap_t50udd_k$($completion));
          }
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              this.listener_1.networkError_y0kx1_k$(e_0);
            } else {
              throw $p;
            }
          }
        }
        return Unit_instance;
      }
      close_yn9xrc_k$() {
        this.webSocketConnection_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'WsProtocol', VOID, VOID, VOID, [0]);
    WsProtocolClass = $;
  }
  return WsProtocolClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  WsFrameType_Text_instance = new (WsFrameType())('Text', 0);
  WsFrameType_Binary_instance = new (WsFrameType())('Binary', 1);
}
var WsFrameType_Text_instance;
var WsFrameType_Binary_instance;
var WsFrameTypeClass;
function WsFrameType() {
  if (WsFrameTypeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'WsFrameType');
    WsFrameTypeClass = $;
  }
  return WsFrameTypeClass;
}
function WsFrameType_Text_getInstance() {
  static_init();
  return WsFrameType_Text_instance;
}
//region block: exports
export {
  WsProtocol as WsProtocol2u70gp1eq7nu9,
  WsFrameType_Text_getInstance as WsFrameType_Text_getInstancea0n74vn6h277,
};
//endregion

//# sourceMappingURL=WsProtocol.mjs.map
